import { Component, OnInit, ViewChild, Input, Output } from '@angular/core' ;
import { FormGroup, NgForm } from '@angular/forms';
import { MatchCities } from '../../../interfaces/match-cities.interface' ;

import { CityInputValidationService } from '../../../services/city-input-validation.service' ;
import { CallAPIService } from '../../../services/call-api.service' ;
import { City } from '../../../interfaces/city.interface' ;

import { CloseDropdownService } from '../../../services/close-dropdown.service' ;
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router' ;

@Component({
  selector: 'form-city-select',
  styleUrls: ['form-city-select.component.scss'],
  template: `
      <div  
        class="btn-group dropdown-group" 
        dropdown #cityDrop="bs-dropdown" [autoClose]="false">
          <form-city-input [form]="form" (newValue)="newValue.next(null)" (inputValue)="syncroCityName($event)" [cityName]="setCityName" class="inline-block inputShorted" ></form-city-input>

          <ul [hidden]=" !isShowCitiesList || ! isCloseCitiesPresent() " id="dropdown-triggers-manual" *dropdownMenu class="cities-dropdown-menu"
              role="menu" aria-labelledby="button-triggers-manual" >
            <div role="menuitem" *ngFor="let city of closeCities" >
              <button type="button" id="{{city.CITY_ID}}" class="dropdown-item" 
              (click)="selectCity( $event.target.textContent, city.CITY_ID ); cityDrop.hide() ; isShowCitiesList = false "  >
                {{ city.SHORTCITYTYPE_UA }} {{ city.CITY_UA }}, {{ city.DISTRICT_UA }} р-н, {{ city.REGION_UA  }} обл.
              </button>
            </div>
            
          </ul>

          <button type="button" [disabled]="! isCloseCitiesPresent() "
            [ngClass]="dropdownButtonClass" 
            class="btn btn-white dropdown-toggle-split dropButton " 
            (click)="isShowCitiesList = ! isShowCitiesList "
            formnovalidate="formnovalidate"  >
              <i class="fas fa-caret-down"></i>
          </button>


      </div>

     
  `
})
export class FormCitySelectComponent implements OnInit { 
      
  @ViewChild('cityDrop', {static: true}) cityDrop;
  @Input('form') form: NgForm ;
  @Output('newValue') newValue: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  isShowCitiesList: boolean = false;
  nameOfValidationDependency: string = 'toWhere';
  inputSelectDependentTo: Observable< MatchCities >;
  closeCities: City[] = Array< City >(); 
  dropdownButtonClass: string;
  setCityName: BehaviorSubject<City> = new BehaviorSubject<City>( undefined );
  inputValue: string ; 
  cityName: string ;
  lastResponseTime: any = null;


  constructor( 
    private cityValidation :CityInputValidationService,
    private apiService: CallAPIService,
    private postageInfo: CallAPIService,
    private router: Router ,
    private closeDropdown: CloseDropdownService, 
  ){ 
    
   }


  ngOnInit(){

    this.dropdownButtonClass = 'greyDropdown';
    this.nameOfValidationDependency = 'toWhere';
    this.apiService.addInputCityToSubscribers( this.nameOfValidationDependency );
    this.apiService.getObservableForeSingleMachingCity().subscribe( (newCity: City)=>{
      this.onChange( newCity );
    })


    this.inputSelectDependentTo  = this.apiService.getObservableCityByInputID( this.nameOfValidationDependency ); 

    this.inputSelectDependentTo.subscribe(( matchCities: MatchCities )=>{
      this.lastResponseTime = Date.now();
      if( matchCities.controlID != undefined  ){
        
        this.closeCities = matchCities.cities; 
        if( this.closeCities && matchCities.citiesCount > 0  ){ 
          //if( matchCities.citiesCount > 1   ){ // || (  + this.cityName == NaN && matchCities.cities[0].CITY_UA.toLocaleLowerCase() != this.cityName.toLocaleLowerCase() && matchCities.cities.length == 1  )
            
          //}
          if(  matchCities.cities.length == 1 && matchCities.cities[0].CITY_UA.toLocaleLowerCase() == this.cityName.toLocaleLowerCase() ){
            this.isShowCitiesList = false ;
            if( this.cityDrop != undefined ) 
              this.cityDrop.hide() ;
          }else{
            this.isShowCitiesList = true ;
            if( this.cityDrop != undefined ) 
              this.cityDrop.show() ;
          }
        }else{
          this.isShowCitiesList = false ;
          if( this.cityDrop != undefined ) 
          this.cityDrop.hide() ;
        }
      }
    });


    this.closeDropdown.addDropdown( this.nameOfValidationDependency ).subscribe( needToClose => {
      let currentResponseTime = Date.now() ;
      let timeInterval 
      if( this.lastResponseTime == null )
        timeInterval = 100000 ;
      else
        timeInterval = currentResponseTime - this.lastResponseTime ;
      
      if( needToClose == true && this.isShowCitiesList == true && timeInterval > 1000 ){
        this.cityDrop.hide()
        this.isShowCitiesList = false ;

      }

    });
  
    // on sturtup
    this.cityDrop.hide()
    this.isShowCitiesList = false ;
  }

  syncroCityName( newCityName ){
    this.cityName = newCityName ;
  }

  selectCity( longCityDescript: string, cityIdNumber: string ){
    this.cityDrop.hide()
    let cityInfo = {}

    let cityId = cityIdNumber;
    cityInfo['CITY_ID'] = cityId;

    let cutStart = longCityDescript.slice( longCityDescript.indexOf(' ',1) );
    let cutEnd = cutStart.slice( 0, cutStart.indexOf(',') ) ;
    
    cityInfo['CITY_UA'] = cutEnd.trim() ;

    let district = cutStart.slice( cutStart.indexOf(',')+2  ) ;
    cityInfo['DISTRICT_UA'] =  district.slice( 0,  district.indexOf(' р-н') )

    let region = district.slice( district.indexOf(', ')+2,  district.indexOf(' обл.') );
    cityInfo['REGION_UA'] = region ;

    
    let cityObject = this.closeCities.filter( function( city ){
      return city['CITY_UA'] == cityInfo['CITY_UA'] && city['DISTRICT_UA'] == cityInfo['DISTRICT_UA'] && city['REGION_UA'] == cityInfo['REGION_UA'] && city['CITY_ID'] == cityInfo['CITY_ID']
    });

    this.onChange( cityObject )
    
  }

  onChange( newValue ) {
    
    if(  Array.isArray( newValue ) ) 
      newValue = newValue[0] ;
   
    if( this.nameOfValidationDependency == 'toWhere'){
      this.postageInfo.clearIndexCityToWhere()
    }
    
    if( newValue != undefined && newValue.CITY_UA != undefined   ){
      
      let clearConfig = this.apiService.buildClearConfig( true, true, true, true, true);
      this.apiService.executeClearWithConfig( clearConfig );
      this.newValue.next(newValue)
      this.setCityName.next( newValue )
      this.apiService.sendRequestIndexByCity( newValue )
    }

  }

  isCloseCitiesPresent():boolean{
    if( this.closeCities == undefined || this.closeCities.length == undefined )
      return false

    return  ( this.closeCities.length > 0 || false )
  }
}
